export default function fitBounds({ ref, bounds }) {
  ref.fitBounds(bounds)
}



// WEBPACK FOOTER //
// ./src/helpers/map/fitBounds.js